<div class="modal-header d-flex justify-content-end">
    <button type="button" class="btn btn-default pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <i class="pi pi-times"></i>
    </button>
</div>
<div style="padding: 30px;">
    <h1 style="text-align: center;">Product Version Changes</h1>
    <h2>{{ diffs.currentProduct.ev_Code }}</h2>
    <br>
    <h2>From Version {{ diffs.previousProduct.revision }} {{ diffs.previousProduct.statusDesc }} ({{
        getDateFormat(diffs.previousProduct.versionDate) }}) to Version {{ diffs.currentProduct.revision }} {{
        diffs.currentProduct.statusDesc }} ({{ getDateFormat(diffs.currentProduct.versionDate) }})</h2>
    <br>
    <div *ngIf="(diffs.differencesAuthorisation && diffs.differencesAuthorisation.length>0) || 
                (diffs.differencesPresentationName && diffs.differencesPresentationName.length>0) || 
               (diffs.pharmaceuticalProductDifferences && diffs.pharmaceuticalProductDifferences.length>0) || 
               (diffs.drugIndicationDifferences) || 
               (diffs.attachmentDifferences) ||
               (diffs.medicinalProductTypeDifferences) ||
               (diffs.atcCodeDifferences) ">

        <table>
            <tr>
                <th style="width: 30%;">Section</th>
                <th style="width: 70%;">Change</th>
            </tr>
            <tr class="separator"></tr>
            <tr *ngFor="let diff of diffs.differencesAuthorisedProduct; let i = index">
                <td [attr.rowspan]="calculateRowspan(diffs.differencesAuthorisedProduct)" *ngIf="i===0">{{ "Authorised
                    Product" }}</td>
                <td><label>
                        <input type="checkbox" (change)="onCheckboxChange(diff, $event.target.checked)" /><span
                            [ngClass]="{'text-green-strikethrough': diff.isChecked,'text-red': !diff.isChecked}"
                            [title]="'Current value: ' + (diff.left?diff.left:'') + '\n\nPrevious value: ' + (diff.right?diff.right:'') ">
                            {{(diff.right?"Changed ":"Added ") + diff.fieldname}}
                        </span>
                    </label>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngFor="let diff of diffs.differencesDevelopmentProduct; let i = index">
                <td [attr.rowspan]="calculateRowspan(diffs.differencesDevelopmentProduct)" *ngIf="i===0">{{ "Development
                    Product" }}</td>
                <td><label>
                        <input type="checkbox" (change)="onCheckboxChange(diff, $event.target.checked)" /><span
                            [ngClass]="{'text-green-strikethrough': diff.isChecked,'text-red': !diff.isChecked}"
                            [title]="'Current value: ' + (diff.left?diff.left:'') + '\n\nPrevious value: ' + (diff.right?diff.right:'') ">
                            {{(diff.right?"Changed ":"Added ") + diff.fieldname}}
                        </span>
                    </label>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngFor="let diff of diffs.differencesAuthorisation; let i = index">
                <td [attr.rowspan]="calculateRowspan(diffs.differencesAuthorisation)" *ngIf="i===0">{{ "Authorisation"
                    }}</td>
                <td><label>
                        <input type="checkbox" (change)="onCheckboxChange(diff, $event.target.checked)" /><span
                            [ngClass]="{'text-green-strikethrough': diff.isChecked,'text-red': !diff.isChecked}"
                            [title]="'Current value: ' + (diff.left?diff.left:'') + '\n\nPrevious value: ' + (diff.right?diff.right:'') ">
                            {{(diff.right?"Changed ":"Added ") + diff.fieldname}}
                        </span>
                    </label>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngIf="diffs.atcCodeDifferences">
                <td>ATC Codes</td>
                <td>
                    <div class="checkbox-container">
                        <div *ngFor="let atc of diffs.atcCodeDifferences.added">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(atc, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': atc.isChecked, 'text-red': !atc.isChecked}">
                                    {{ "Added ATC code " + atc.atccode + " - " + atc.atccode_Desc }}
                                </span>
                            </label>
                        </div>
                        <div *ngFor="let atc of diffs.atcCodeDifferences.removed">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(atc, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': atc.isChecked, 'text-red': !atc.isChecked}">
                                    {{ "Removed ATC code " + atc.atccode + " - " + atc.atccode_Desc }}
                                </span>
                            </label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngIf="diffs.medicinalProductTypeDifferences">
                <td>Medicinal Product Types</td>
                <td>
                    <div class="checkbox-container">
                        <div *ngFor="let mpt of diffs.medicinalProductTypeDifferences.added">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(mpt, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': mpt.isChecked, 'text-red': !mpt.isChecked}">
                                    {{ "Added Medicinal Product Type " + mpt.code + " - " + mpt.name }}
                                </span>
                            </label>
                        </div>
                        <div *ngFor="let mpt of diffs.medicinalProductTypeDifferences.removed">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(mpt, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': mpt.isChecked, 'text-red': !mpt.isChecked}">
                                    {{ "Removed Medicinal Product Type " + mpt.code + " - " + mpt.name }}
                                </span>
                            </label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngIf="diffs.previousEvCodeDifferences">
                <td>Previous EV Codes</td>
                <td>
                    <div class="checkbox-container">
                        <div *ngFor="let pevcode of diffs.previousEvCodeDifferences.added">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(pevcode, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': pevcode.isChecked, 'text-red': !pevcode.isChecked}">
                                    {{ "Added Previous EV Code " + pevcode.devevcode.value + " - " +
                                    pevcode.devevcode.name }}
                                </span>
                            </label>
                        </div>
                        <div *ngFor="let pevcode of diffs.previousEvCodeDifferences.removed">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(pevcode, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': pevcode.isChecked, 'text-red': !pevcode.isChecked}">
                                    {{ "Removed Previous EV Code " + pevcode.devevcode.value + " - " +
                                    pevcode.devevcode.name }}
                                </span>
                            </label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngIf="diffs.drugIndicationDifferences">
                <td>Drug Indications</td>
                <td>
                    <div class="checkbox-container">
                        <!-- Added Drug Indications -->
                        <div *ngFor="let drugindication of diffs.drugIndicationDifferences.added">
                            <label>
                                <input type="checkbox"
                                    (change)="onCheckboxChange(drugindication, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': drugindication.isChecked, 'text-red': !drugindication.isChecked}">
                                    {{ "Added Drug Indication " + drugindication.meddraValue + " - " +
                                    drugindication.meddraversion + " - " + drugindication.meddraName }}
                                </span>
                            </label>
                        </div>
                        <!-- Modified Drug Indications -->
                        <div *ngFor="let drugindication of diffs.drugIndicationDifferences.modified">
                            <label>
                                <input type="checkbox"
                                    (change)="onCheckboxChange(drugindication, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': drugindication.isChecked, 'text-red': !drugindication.isChecked}">
                                    {{ "Changed Drug Indication " + drugindication.meddraValue + " - " +
                                    drugindication.meddraversion + " - " + drugindication.meddraName }}
                                </span>
                            </label>
                        </div>
                        <!-- Removed Drug Indications -->
                        <div *ngFor="let drugindication of diffs.drugIndicationDifferences.removed">
                            <label>
                                <input type="checkbox"
                                    (change)="onCheckboxChange(drugindication, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': drugindication.isChecked, 'text-red': !drugindication.isChecked}">
                                    {{ "Removed Drug Indication " + drugindication.meddraValue + " - " +
                                    drugindication.meddraversion + " - " + drugindication.meddraName }}
                                </span>
                            </label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngFor="let diff of diffs.pharmaceuticalProductDifferences" style="border-bottom: 1px solid black">

                <td>Pharmaceutical Product {{ diff.pharmaceuticalProductForm.pharmaceuticalForm.ev_Code + " / " +
                    diff.pharmaceuticalProductForm.pharmaceuticalForm.name_Pharmform }}</td>

                <td>
                    <div *ngIf="diff.operation==='NEW'"> <label>
                            <input type="checkbox" (change)="onCheckboxChange(diff, $event.target.checked)">
                            <span [ngClass]="{'text-green-strikethrough': diff.isChecked, 'text-red': !diff.isChecked}">
                                Added
                            </span>
                        </label></div>
                    <div *ngIf="diff.operation==='DELETED'"><label>
                            <input type="checkbox" (change)="onCheckboxChange(diff, $event.target.checked)">
                            <span [ngClass]="{'text-green-strikethrough': diff.isChecked, 'text-red': !diff.isChecked}">
                                Removed
                            </span>
                        </label></div>
                    <div *ngIf="diff.operation==='UPDATED'">
                        <div *ngIf="diff.roasDiff">

                            <div *ngFor="let roa of diff.roasDiff.added">
                                <label>
                                    <input type="checkbox" (change)="onCheckboxChange(roa, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': roa.isChecked, 'text-red': !roa.isChecked}">
                                        {{ "Added Admin Route " + roa.ev_Code + " - " + roa.name_Admroute }}
                                    </span>
                                </label>
                            </div>
                            <div *ngFor="let roa of diff.roasDiff.modified">
                                <label>
                                    <input type="checkbox" (change)="onCheckboxChange(roa, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': roa.isChecked, 'text-red': !roa.isChecked}">
                                        {{ "Changed Admin Route " + roa.ev_Code + " - " + roa.name_Admroute }}
                                    </span>
                                </label>
                            </div>
                            <div *ngFor="let roa of diff.roasDiff.removed">
                                <label>
                                    <input type="checkbox" (change)="onCheckboxChange(roa, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': roa.isChecked, 'text-red': !roa.isChecked}">
                                        {{ "Removed Admin Route " + roa.ev_Code + " - " + roa.name_Admroute }}
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div *ngIf="diff.drugIngredientDiff">
                            <div *ngFor="let drugIngredient of diff.drugIngredientDiff.added">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(drugIngredient, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': drugIngredient.isChecked, 'text-red': !drugIngredient.isChecked}">
                                        {{ "Added Drug Ingredient " + drugIngredient.substancecode.value + " - " +
                                        drugIngredient.substancecode.name }}
                                    </span>
                                </label>
                            </div>
                            <div *ngFor="let drugIngredient of diff.drugIngredientDiff.modified">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(drugIngredient, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': drugIngredient.isChecked, 'text-red': !drugIngredient.isChecked}">
                                        {{ "Removed Drug Ingredient " + drugIngredient.substancecode.value + " - " +
                                        drugIngredient.substancecode.name }}
                                    </span>
                                </label>
                            </div>
                            <div *ngFor="let drugIngredient of diff.drugIngredientDiff.removed">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(drugIngredient, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': drugIngredient.isChecked, 'text-red': !drugIngredient.isChecked}">
                                        {{ "Removed Drug Ingredient " + drugIngredient.substancecode.value + " - " +
                                        drugIngredient.substancecode.name }}
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div *ngIf="diff.oldDrugIngredientDiff">
                            <div *ngFor="let drugIngredient of diff.oldDrugIngredientDiff.added">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(drugIngredient, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': drugIngredient.isChecked, 'text-red': !drugIngredient.isChecked}">
                                        {{ "Added Old Drug Ingredient " + drugIngredient.substancecode.value + " - " +
                                        drugIngredient.substancecode.name }}
                                    </span>
                                </label>
                            </div>
                            <div *ngFor="let drugIngredient of diff.oldDrugIngredientDiff.removed">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(drugIngredient, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': drugIngredient.isChecked, 'text-red': !drugIngredient.isChecked}">
                                        {{ "Removed Old Drug Ingredient " + drugIngredient.substancecode.value + " - " +
                                        drugIngredient.substancecode.name }}
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div *ngIf="diff.medicalDeviceDiff">
                            <div *ngFor="let medicaldevice of diff.medicalDeviceDiff.added">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(medicaldevice, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': medicaldevice.isChecked, 'text-red': !medicaldevice.isChecked}">
                                        {{ "Added Medical Device " + medicaldevice.code + " - " +
                                        medicaldevice.medicalDeviceName }}
                                    </span>
                                </label>
                            </div>
                            <div *ngFor="let medicaldevice of diff.medicalDeviceDiff.modified">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(medicaldevice, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': medicaldevice.isChecked, 'text-red': !medicaldevice.isChecked}">
                                        {{ "Modified Medical Device " + medicaldevice.code + " - " +
                                        medicaldevice.medicalDeviceName }}
                                    </span>
                                </label>
                            </div>
                            <div *ngFor="let medicaldevice of diff.medicalDeviceDiff.removed">
                                <label>
                                    <input type="checkbox"
                                        (change)="onCheckboxChange(medicaldevice, $event.target.checked)">
                                    <span
                                        [ngClass]="{'text-green-strikethrough': medicaldevice.isChecked, 'text-red': !medicaldevice.isChecked}">
                                        {{ "Removed Medical Device " + medicaldevice.code + " - " +
                                        medicaldevice.medicalDeviceName }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngIf="diffs.attachmentDifferences">
                <td>Attachments</td>
                <td>
                    <div class="checkbox-container">
                        <div *ngFor="let attachment of diffs.attachmentDifferences.added">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(attachment, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': attachment.isChecked, 'text-red': !attachment.isChecked}">
                                    {{ "Added Attachment " + attachment.ev_Code + " - " + attachment.attachmentname }}
                                </span>
                            </label>
                        </div>
                        <div *ngFor="let attachment of diffs.attachmentDifferences.removed">
                            <label>
                                <input type="checkbox" (change)="onCheckboxChange(attachment, $event.target.checked)">
                                <span
                                    [ngClass]="{'text-green-strikethrough': attachment.isChecked, 'text-red': !attachment.isChecked}">
                                    {{ "Removed Attachment " + attachment.ev_Code + " - " + attachment.attachmentname }}
                                </span>
                            </label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="separator"></tr>
            <tr *ngFor="let diff of diffs.differencesPresentationName; let i = index">
                <td [attr.rowspan]="calculateRowspan(diffs.differencesPresentationName)" *ngIf="i===0">{{ "Presentation"
                    }}</td>
                <td><label>
                        <input type="checkbox" (change)="onCheckboxChange(diff, $event.target.checked)" /><span
                            [ngClass]="{'text-green-strikethrough': diff.isChecked,'text-red': !diff.isChecked}"
                            [title]="'Current value: ' + (diff.left?diff.left:'') + '\n\nPrevious value: ' + (diff.right?diff.right:'') ">
                            {{(diff.right?"Changed ":"Added ") + diff.fieldname}}
                        </span>
                    </label>
                </td>
            </tr>
            <tr class="separator"></tr>
        </table>

    </div>
    <div *ngIf="((!diffs.differencesAuthorisation) || diffs.differencesAuthorisation.length==0) && 
            ((!diffs.differencesPresentationName) || diffs.differencesPresentationName.length==0) &&
               ((!diffs.pharmaceuticalProductDifferences) || diffs.pharmaceuticalProductDifferences.length==0) && 
               (!diffs.drugIndicationDifferences)  &&
               (!diffs.attachmentDifferences)  &&
               (!diffs.medicinalProductTypeDifferences)  &&
               (!diffs.previousEvCodeDifferences)  &&
               (!diffs.atcCodeDifferences) ">
        <h2 style="text-align: center;">The two versions are identical</h2>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="bsModalRef.hide()">Close</button>
</div>